import { Button, Text, Spinner } from '@chakra-ui/react';
import React from 'react';
import AiAssistIcon from '../../icons/AIAssistIcon/AIAssistIcon';
import ConditionalTooltip from '../Tooltip/ConditionalTooltip';
import { useTokens } from '../../../context/TokenProvider';
import { makeMed4 } from '../../../styles/textStyles';
import { RenderIf } from '../RenderIf/RenderIf';
import { localise } from '../../../services/lang/lang';
const AiAssistButton = ({ shouldShowTooltip, isWorking, label }) => {
    const tokens = useTokens();
    return (React.createElement(ConditionalTooltip, { condition: shouldShowTooltip, placement: "right", shouldWrapChildren: true, label: label },
        React.createElement(Button, { "aria-label": label, leftIcon: React.createElement(AiAssistIcon, null), maxH: "28px", variant: "ghost", minHeight: "28px", "data-testid": "ai_assist_button", px: tokens.Spacing03 },
            React.createElement(Text, { sx: makeMed4(tokens) }, localise('SUMMARISE')),
            React.createElement(RenderIf, { condition: isWorking },
                React.createElement(Spinner, { "data-testid": "ai_assist_button__spinner", color: "#2AA3A3", size: "xs", ml: 2 })))));
};
export default AiAssistButton;
